import { Button } from '@material-ui/core';
import './TableActionButton.scss';

export const TableActionButton = (props) => {
  const { label, onClick, btnClass, disabled } = props;
  return (
    <Button
      disabled={disabled}
      variant='contained'
      className={`table-action-btn ${btnClass}`}
      size='small'
      onClick={onClick}
    >
      {label}
    </Button>
  );
};
